// Module for feature flags defined in Firebase Remote Config. Name must match
// the flag name in Firebase Remote Config. See example flag below.
export const FLAG_EXAMPLE = {
  defaultValue: true,
  name: 'foo',
};
